import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=ab6fc916&scoped=true&"
import script from "./ModalStaff.vue?vue&type=script&lang=js&"
export * from "./ModalStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=ab6fc916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6fc916",
  null
  
)

export default component.exports